import React from "react";
import ChildRatingStar from "./ChildRatingStar";

export default function RatingReviewsComponent({ formData, rating = true }) {
  const StarRating = ({ rating }) => {
    const maxStars = 5;
    return (
      <div className="star-sec">
        {[...Array(maxStars)].map((_, i) => (
          <i
            key={i}
            className={i < rating ? "fa-solid fa-star" : "fa-solid fa-star disabled"}
          ></i>
        ))}
      </div>
    );
  };

  const hasRatings =
    (formData?.ratings && formData.ratings.length > 0) ||
    (formData?.avg_rating && Number(formData.avg_rating) > 0);

  return (
    <div className="recently-post similar-products w-100">
      <div className="similar-head flex-column px-0">
        <h2 className="review-rate-head justify-content-center">Rating and Reviews</h2>

        <div className="rating-sec">
          {hasRatings ? (
            <>
              {rating && (
                <div className="overall-rating mx-auto">
                  <div className="earn-head">
                    <>
                      <div className="star">
                        <p className="d-flex flex-column ">
                          Average Rating &nbsp;
                          <span>
                            <i className="fa-solid fa-star"></i>
                            <span>{formData?.avg_rating || 0}</span> (
                            {formData?.comment_count || 0}) reviews
                          </span>
                        </p>
                      </div>
                      <h2></h2>
                      <div className="earn-head">
                        <div className="star">
                          <p>
                            {" "}
                            Completion Rating &nbsp;
                            <span>
                              {formData?.completed_work_percentage || 0} %
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="earn-head">
                        <h2></h2>
                        <div className="star">
                          <p>
                            Overall Rating &nbsp;
                            <span>{formData?.over_all_rating || 0} %</span>
                          </p>
                        </div>
                      </div>
                    </>
                  </div>

                  <div className="review-right">
                    {formData.rating_category &&
                      formData.rating_category.map((rat_cat, indi) => (
                        <div className="review-star" key={indi}>
                          <p>{rat_cat.title}</p>
                          <StarRating rating={Number(rat_cat.rating)} />
                        </div>
                      ))}
                  </div>
                </div>
              )}
              <ChildRatingStar ratings={formData.ratings} />
            </>
          ) : (
            // 🧠 No ratings found box
            <div
              className="no-ratings-box"
              style={{
                textAlign: "center",
                padding: "40px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                background: "#fafafa",
                color: "#666",
                marginTop: "20px",
              }}
            >
              <i className="fa-regular fa-star" style={{ fontSize: "24px" }}></i>
              <p style={{ marginTop: "10px", fontSize: "16px" }}>
                No ratings yet
              </p>
            </div>
          )}
        </div>
      </div>
    </div >
  );
}
